/* Personnalisation "gravure".
   - simple  : champ texte natif (valeur -> line item property, inchangé) ;
   - metallique (show_preview, ex. Carre Parisien) : le client ecrit sur un carre de zinc
     en focus (<dialog> natif, top layer, fond floute ::backdrop). Le texte est saisi dans
     un <input> stylise "grave" qui remplit le carre (toujours focusable/typable), puis
     recopie dans un <input> cache (desactive si vide -> pas de propriete vide au panier).
     "Valider" replie le carre en miniature (FLIP).
   Le focus ne s'ouvre QU'A l'activation par l'utilisateur (variantChange), jamais au load. */
(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');

  // span de mesure partage pour l'auto-fit des <input>
  var MIRROR = document.createElement('span');
  MIRROR.setAttribute('aria-hidden', 'true');
  MIRROR.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;left:-9999px;top:0;margin:0;padding:0;pointer-events:none;';
  (document.body || document.documentElement).appendChild(MIRROR);

  // Gravure differente par objet quand la quantite commandee est > 1 : un
  // petit bandeau d'onglets (1, 2, 3...) permet de choisir quel objet on est
  // en train de graver. Un seul champ/carre visible a la fois (celui de
  // l'onglet actif) ; les textes des autres objets sont portes par des
  // <input type="hidden"> "ombres", ajoutes/retires au fil des onglets, et
  // nommes "{label} - Objet N" pour rester lisibles dans la commande.
  function makeMultiController(block, opts) {
    var tabsEl = block.querySelector('[data-tdp-tabs]');
    if (!tabsEl || !opts || !opts.visibleInput) return null;

    var sameWrap = block.querySelector('[data-tdp-same-wrap]');
    var sameCheckbox = sameWrap && sameWrap.querySelector('[data-tdp-same-all]');
    // Cochee par defaut : la plupart des clients veulent la meme gravure sur
    // tous les objets, et oublier de personnaliser un objet individuellement
    // bloquait l'ajout au panier sans que le client comprenne pourquoi (le
    // message d'erreur restait cache derriere la fenetre de gravure ouverte
    // automatiquement - cf. showMissingError plus bas). Le client peut
    // decocher s'il veut personnaliser differemment chaque objet. Valeur
    // forcee explicitement au chargement (plutot que de laisser le
    // navigateur restaurer un etat via bfcache/autofill), pour un
    // comportement previsible a chaque visite.
    if (sameCheckbox) sameCheckbox.checked = true;

    var fieldLabel = block.dataset.fieldLabel || '';
    var visibleInput = opts.visibleInput;
    var texts = [opts.getVisibleValue() || ''];
    var activeIndex = 0;
    var shadows = {};
    // "Meme gravure pour tous les objets" : tant que coche, le texte de
    // l'objet 1 est copie sur tous les autres a chaque modification, et la
    // navigation vers les autres onglets est verrouillee (evite de laisser
    // croire qu'on peut diverger d'un objet a l'autre pendant que c'est actif).
    var sameForAll = !!(sameCheckbox && sameCheckbox.checked);
    // Fenetre glissante du bandeau d'onglets au-dela de 6 objets (defilement
    // reel, cf. renderTabs) : index (0-based) du premier onglet visible.
    var windowStart = 0;

    function applySameForAll() {
      texts[activeIndex] = opts.getVisibleValue();
      var master = texts[0] || '';
      var q = qty();
      for (var i = 1; i < q; i++) {
        texts[i] = master;
        syncShadow(i);
      }
      if (activeIndex !== 0) {
        activeIndex = 0;
        syncVisibleName();
        opts.setVisibleValue(master);
        if (opts.onLoad) opts.onLoad(master);
      }
    }

    // Quand on decoche : la copie faite par applySameForAll ne doit pas
    // rester - seul l'objet 1 garde son texte, les autres repartent a vide
    // ("a definir"). L'objet 1 reste actif (applySameForAll y ramene deja
    // la navigation), donc rien a changer cote input/apercu visibles.
    function clearAllButFirst() {
      var q = qty();
      for (var i = 1; i < q; i++) {
        texts[i] = '';
        syncShadow(i);
      }
    }

    function qty() {
      // One personalization per cart line; never change the purchased quantity.
      // The capability is emitted by Liquid for the custom-map product only.
      if (block.dataset.engravingMode === 'single') return 1;
      var scope = block.closest('product-info') || document;
      var q = scope.querySelector('.quantity__input');
      var n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    function propName(index, q) {
      if (q <= 1) return 'properties[' + fieldLabel + ']';
      return 'properties[' + fieldLabel + ' - Objet ' + (index + 1) + ']';
    }

    function ensureShadow(index) {
      if (shadows[index]) return shadows[index];
      var el = document.createElement('input');
      el.type = 'hidden';
      el.id = (visibleInput.id || 'tdp-perso') + '-objet-' + (index + 1);
      // Le rattachement au <form> se fait par l'attribut form="..." (l'input
      // n'est pas forcement un descendant DOM du <form>) : sans le recopier
      // ici, ce clone n'appartient a aucun formulaire et ne serait jamais
      // soumis avec la commande.
      var formAttr = visibleInput.getAttribute('form');
      if (formAttr) el.setAttribute('form', formAttr);
      el.disabled = true;
      visibleInput.insertAdjacentElement('afterend', el);
      shadows[index] = el;
      return el;
    }

    function syncShadow(index) {
      var el = ensureShadow(index);
      var val = texts[index] || '';
      el.name = propName(index, qty());
      el.value = val;
      el.disabled = val === '' || index >= qty();
    }

    function syncVisibleName() {
      visibleInput.name = propName(activeIndex, qty());
    }

    function isActiveBlock() {
      return block.dataset.tdpActive === 'true';
    }

    function renderTabs() {
      var q = qty();
      // Le recadrage de l'onglet actif doit se faire AVANT le retour anticipe
      // ci-dessous (bandeau masque si q<=1) : sinon, en cas de reduction de
      // quantite pendant qu'un objet autre que le 1er est affiche, l'input
      // visible garderait le mauvais texte associe au mauvais nom de propriete.
      if (activeIndex >= q) selectTab(Math.max(q - 1, 0), true);
      var showBanner = isActiveBlock() && q > 1;
      if (sameWrap) sameWrap.hidden = !showBanner;
      if (!showBanner) {
        tabsEl.hidden = true;
        tabsEl.innerHTML = '';
        return;
      }
      // "Meme gravure pour tous" coche : plus besoin de choisir un objet
      // (tous portent deja le meme texte), le bandeau d'onglets disparait.
      if (sameForAll) {
        tabsEl.hidden = true;
        tabsEl.innerHTML = '';
        return;
      }
      // Au-dela de 6 objets : fenetre glissante de 4 onglets consecutifs,
      // puis "..." puis le DERNIER objet (toujours affiche, quel que soit
      // l'endroit ou on defile) + fleches prev/suivant. En avancant au-dela
      // du 4e, le premier onglet visible s'incremente (1..4 -> 2..5 -> ...),
      // pour un vrai defilement plutot qu'une simple troncature statique.
      var truncated = q > 5;
      var windowSize = 3;
      var lastIndex = q - 1;
      var maxWindowStart = Math.max(0, lastIndex - windowSize);
      if (!truncated) {
        windowStart = 0;
      } else if (activeIndex !== lastIndex) {
        if (activeIndex < windowStart) windowStart = activeIndex;
        if (activeIndex > windowStart + windowSize - 1) windowStart = activeIndex - windowSize + 1;
      }
      windowStart = Math.max(0, Math.min(windowStart, maxWindowStart));

      var indexesToShow = [];
      if (truncated) {
        for (var w = windowStart; w < windowStart + windowSize; w++) indexesToShow.push(w);
      } else {
        for (var n = 0; n < q; n++) indexesToShow.push(n);
      }

      function renderTabButton(i) {
        return (
          '<button type="button" class="tdp-perso__tab' +
          (i === activeIndex ? ' is-active' : '') +
          (texts[i] ? ' is-filled' : '') +
          '" data-tdp-tab="' +
          i +
          '" aria-pressed="' +
          (i === activeIndex) +
          '">' +
          (i + 1) +
          '</button>'
        );
      }

      var html = '';
      if (truncated) {
        html +=
          '<button type="button" class="tdp-perso__tab-arrow" data-tdp-tab-prev aria-label="' +
          (block.dataset.i18nPrevItem || '') +
          '"' + (activeIndex === 0 ? ' disabled' : '') + '>‹</button>';
      }
      for (var pos = 0; pos < indexesToShow.length; pos++) html += renderTabButton(indexesToShow[pos]);
      if (truncated) {
        // Fenetre collee au dernier objet (les 5 derniers numeros se suivent
        // deja) : plus besoin des "..." pour signaler un saut.
        var adjacentToLast = windowStart === maxWindowStart;
        if (!adjacentToLast) html += '<span class="tdp-perso__tab-ellipsis" aria-hidden="true">…</span>';
        html += renderTabButton(lastIndex);
        html +=
          '<button type="button" class="tdp-perso__tab-arrow" data-tdp-tab-next aria-label="' +
          (block.dataset.i18nNextItem || '') +
          '"' + (activeIndex === q - 1 ? ' disabled' : '') + '>›</button>';
      }
      tabsEl.innerHTML = html;
      tabsEl.hidden = false;
    }

    function selectTab(index, silent) {
      if (index === activeIndex) return;
      texts[activeIndex] = opts.getVisibleValue();
      syncShadow(activeIndex);
      activeIndex = index;
      if (shadows[activeIndex]) {
        shadows[activeIndex].disabled = true;
        shadows[activeIndex].value = '';
      }
      syncVisibleName();
      opts.setVisibleValue(texts[activeIndex] || '');
      if (opts.onLoad) opts.onLoad(texts[activeIndex] || '');
      if (!silent) renderTabs();
    }

    tabsEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-tdp-tab-prev]')) {
        if (activeIndex > 0) selectTab(activeIndex - 1);
        return;
      }
      if (e.target.closest('[data-tdp-tab-next]')) {
        if (activeIndex < qty() - 1) selectTab(activeIndex + 1);
        return;
      }
      var btn = e.target.closest('[data-tdp-tab]');
      if (btn) selectTab(Number(btn.dataset.tdpTab));
    });

    if (sameCheckbox) {
      sameCheckbox.addEventListener('change', function () {
        sameForAll = sameCheckbox.checked;
        if (sameForAll) applySameForAll();
        else clearAllButFirst();
        renderTabs();
      });
    }

    function onValueCommitted(text) {
      texts[activeIndex] = text;
      if (sameForAll && activeIndex === 0) {
        var q = qty();
        for (var i = 1; i < q; i++) texts[i] = text;
        Object.keys(shadows).forEach(function (k) {
          if (Number(k) !== 0) syncShadow(Number(k));
        });
      }
      renderTabs();
      // Le message d'erreur "texte de gravure manquant" (affiche par
      // validatePersonalizationBeforeSubmit) ne se cachait que lors d'un
      // nouvel essai de soumission - on l'efface des que le texte manquant
      // est rempli, sans attendre un reclic sur "Ajouter au panier".
      if (getMissingSlots().length === 0) clearMissingTextError(block);
    }

    function onQuantityChange() {
      var q = qty();
      while (texts.length < q) texts.push(sameForAll ? (texts[0] || '') : '');
      // Cree/synchronise tout de suite le shadow input de chaque nouvel objet
      // (pas seulement ceux deja crees) : sans ca, un objet jamais visite
      // resterait sans input dans le DOM jusqu'au premier clic sur son
      // onglet, une fenetre inutile pendant laquelle son etat reste flou.
      for (var idx = 0; idx < q; idx++) {
        if (idx !== activeIndex) syncShadow(idx);
      }
      syncVisibleName();
      renderTabs();
    }

    function setAllDisabled(disabled) {
      Object.keys(shadows).forEach(function (k) {
        var index = Number(k);
        shadows[k].disabled = disabled || texts[index] === '' || index >= qty();
      });
      renderTabs();
    }

    // Renvoie les index (0-based) des objets sans texte de gravure, en tenant
    // compte de la valeur actuellement affichee (pas encore "commit-ee" dans
    // `texts` tant qu'on ne change pas d'onglet).
    function getMissingSlots() {
      texts[activeIndex] = opts.getVisibleValue();
      var q = qty();
      var missing = [];
      for (var i = 0; i < q; i++) {
        if (!(texts[i] || '').trim()) missing.push(i);
      }
      return missing;
    }

    // Amene le client sur l'objet manquant (bascule l'onglet si besoin, puis
    // ouvre l'editeur/le focus), pour qu'il puisse corriger immediatement.
    function focusSlot(index) {
      if (index !== activeIndex) selectTab(index);
      if (opts.onFocus) opts.onFocus();
    }

    // Restaure les textes en revenant du panier (cf. restoreFromCartLink) :
    // list[i] = texte de l'objet i+1. L'objet 1 reste actif, donc l'input/
    // apercu visibles sont rafraichis pour refleter sa valeur restauree.
    function restoreTexts(list) {
      var q = qty();
      for (var i = 0; i < list.length && i < q; i++) {
        texts[i] = list[i] || '';
        if (i !== activeIndex) syncShadow(i);
      }
      opts.setVisibleValue(texts[activeIndex] || '');
      if (opts.onLoad) opts.onLoad(texts[activeIndex] || '');
      renderTabs();
    }

    syncVisibleName();
    renderTabs();

    // Textes de tous les objets commandes (objet 1 = index 0), y compris la
    // valeur affichee pas encore "commit-ee".
    function getTexts() {
      texts[activeIndex] = opts.getVisibleValue();
      return texts.slice(0, qty()).map(function (t) { return t || ''; });
    }

    return {
      getTexts: getTexts,
      onValueCommitted: onValueCommitted,
      onQuantityChange: onQuantityChange,
      setAllDisabled: setAllDisabled,
      restoreTexts: restoreTexts,
      getMissingSlots: getMissingSlots,
      focusSlot: focusSlot,
    };
  }

  function computeActive(block, variant, directValue) {
    if (block.dataset.alwaysActive === 'true') return true;
    var needle = block.dataset.optionValue || '';
    var cur;
    if (typeof directValue === 'string') {
      cur = directValue.toLowerCase();
    } else {
      var idx = Number(block.dataset.optionIndex);
      cur = (variant && variant.options && variant.options[idx]
        ? variant.options[idx]
        : block.dataset.initialOptionValue || ''
      ).toLowerCase();
    }
    return needle !== '' && cur.indexOf(needle) !== -1;
  }

  // Certains produits changent le FORMAT de l'apercu (portrait/paysage) selon
  // la valeur choisie sur une option de design (ex. "Skyline" sur le porte-cle
  // grave Paris) - pas seulement l'activation de la gravure. On ecoute chaque
  // input/select de variante en DIRECT (evenement natif "change", synchrone),
  // plutot que l'evenement Shopify variantChange qui n'arrive qu'apres l'appel
  // reseau de mise a jour du prix - ca evite un flash/blocage sur l'ancien
  // format tant que la reponse serveur n'est pas revenue (corrige : il fallait
  // recharger la page pour voir le bon format apres un changement de variante).
  function applyKeychainRatio(block, value) {
    // Le <dialog> est deplace dans <body> a l'initialisation (cf. initMetallic) -
    // il ne fait donc plus partie du sous-arbre de "block" et n'est plus trouvable
    // via block.querySelector des que la page a fini de charger. La reference
    // conservee sur block._tdp.overlay reste valide, elle.
    var overlay = block._tdp && block._tdp.overlay;
    if (!overlay) return;
    var landscape = (value || '').trim().toLowerCase() === 'skyline';
    overlay.classList.toggle('tdp-perso--keychain2', landscape);
    overlay.classList.toggle('tdp-perso--keychain', !landscape);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    var name = target && target.name;
    if (!name) return;
    var match = /^options\[(.+)\]$/.exec(name);
    if (!match) return;
    var optionName = match[1];
    document.querySelectorAll('[data-product-personalization][data-keychain-ratio-option-name]').forEach(function (block) {
      if (block.dataset.keychainRatioOptionName === optionName) applyKeychainRatio(block, target.value);
    });
  });

  // Active/desactive le bloc de personnalisation DIRECTEMENT au clic sur
  // l'option (ex. "Avec gravure"), sans attendre l'evenement Shopify
  // variantChange (qui depend d'un aller-retour reseau pour resoudre la
  // variante). Necessaire pour les produits dont TOUTES les variantes sont en
  // rupture de stock (ex. "Me notifier lorsque cet article est disponible") :
  // selon la combinaison, Shopify peut ne pas renvoyer de variante resolue,
  // et l'evenement variantChange n'est alors jamais publie - l'apercu de
  // gravure restait alors bloque sur son etat initial (cache).
  document.addEventListener('change', function (event) {
    var target = event.target;
    var optionName = target && target.dataset && target.dataset.optionName;
    if (!optionName) return;
    var optionNameLower = optionName.trim().toLowerCase();
    document.querySelectorAll('[data-product-personalization]').forEach(function (block) {
      if (block.dataset.alwaysActive === 'true') return;
      if (block.dataset.optionName !== optionNameLower) return;
      toggle(block, null, true, target.value);
    });
  });

  function toggle(block, variant, userInitiated, directValue) {
    var active = computeActive(block, variant, directValue);
    var was = block.dataset.tdpActive === 'true';
    block.dataset.tdpActive = active ? 'true' : 'false';
    block.querySelectorAll('[data-personalization-field]').forEach(function (el) {
      el.hidden = !active;
      el.style.display = active ? '' : 'none';
    });
    // TDP — la rubrique "Suggestion" (produits similaires) disparait tant que
    // "Avec gravure" est actif, en plus de disparaitre quand la description
    // est depliee (cf. tdp-description-toggle.js) : les deux conditions sont
    // independantes, chacune pilote sa propre classe pour ne pas s'ecraser.
    var scope = block.closest('product-info') || block.closest('.product') || document;
    var related = scope.querySelector('.tdp-related-products');
    if (related) related.classList.toggle('tdp-related-products--engrave', active);
    var i = block.querySelector('input[name^="properties["]');
    if (!active) {
      // Desactive la propriete panier SANS effacer le texte deja saisi, pour
      // le retrouver si l'option "avec gravure" est reselectionnee ensuite.
      if (block._tdp) block._tdp.deactivate();
      else if (i) i.disabled = true;
      return;
    }
    if (block._tdp) block._tdp.activate();
    else if (i) i.disabled = false;
    // Gravure choisie : prepare la police vectorielle des fichiers de production.
    if (block._tdp && block._tdp.measure) preloadVectorFont();
    // N'ouvre l'editeur automatiquement que si aucun texte n'a deja ete
    // saisi : repasser sur "sans gravure" puis revenir sur "avec gravure"
    // ne doit pas rouvrir la fenetre si la gravure est deja renseignee -
    // le client peut toujours cliquer sur "Personnaliser" s'il veut la modifier.
    if (active && !was && userInitiated && block._tdp && block._tdp.open && block._tdp.isEmpty && block._tdp.isEmpty()) {
      block._tdp.open();
    }
  }

  // Auto-fit d'un <input> via span miroir (single line, on ajuste la taille a la largeur).
  function fitInput(el, opts) {
    opts = opts || {};
    var host = el.parentElement;
    if (!host || !host.clientWidth) return 0;
    var cs = getComputedStyle(el);
    var availW = (el.clientWidth - (parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight))) * 0.98;
    var minPx = opts.min || 12, maxPx = opts.max || Math.round(host.clientHeight * 0.5);
    MIRROR.style.fontFamily = cs.fontFamily; MIRROR.style.fontWeight = cs.fontWeight;
    MIRROR.style.letterSpacing = cs.letterSpacing; MIRROR.style.textTransform = cs.textTransform;
    MIRROR.textContent = el.value || el.placeholder || '';
    var lo = minPx, hi = maxPx, best = minPx;
    while (lo <= hi) { var mid = (lo + hi) >> 1; MIRROR.style.fontSize = mid + 'px'; if (MIRROR.getBoundingClientRect().width > availW) hi = mid - 1; else { best = mid; lo = mid + 1; } }
    el.style.fontSize = best + 'px'; return best;
  }

  // Auto-fit d'un <p> (miniature / flyer) via Range.
  function fitRange(el, opts) {
    opts = opts || {};
    var host = el.parentElement;
    if (!host || !host.clientWidth) return 0;
    var minPx = opts.min || 12, maxPx = opts.max || Math.round(host.clientHeight * 0.42), wrapAt = opts.wrapBelow || 34;
    var cs = getComputedStyle(el);
    var availW = el.clientWidth - (parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight));
    var availH = (el.clientHeight - (parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom))) * 0.96;
    var prevT = el.style.transition; el.style.transition = 'none';
    function measure() { if (!el.firstChild) return { w: 0, h: 0 }; var r = document.createRange(); r.selectNodeContents(el); var b = r.getBoundingClientRect(); return { w: b.width, h: b.height }; }
    function overflows() { var m = measure(); return m.w > availW || m.h > availH; }
    function search() { var lo = minPx, hi = maxPx, best = minPx; while (lo <= hi) { var mid = (lo + hi) >> 1; el.style.fontSize = mid + 'px'; if (overflows()) hi = mid - 1; else { best = mid; lo = mid + 1; } } el.style.fontSize = best + 'px'; return best; }
    if (/\n/.test(el.textContent)) { el.style.whiteSpace = 'pre-wrap'; var sizeNL = search(); el.style.transition = prevT; return sizeNL; }
    el.style.whiteSpace = 'nowrap'; var size = search();
    if (size < wrapAt && /\s/.test(el.textContent)) { el.style.whiteSpace = 'normal'; var w = search(); if (w > size) size = w; else { el.style.whiteSpace = 'nowrap'; el.style.fontSize = size + 'px'; } }
    el.style.transition = prevT; return size;
  }

  function fitText(el, opts) { return (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') ? fitInput(el, opts) : fitRange(el, opts); }

  // Sur les pieces reelles, une gravure courte est ecrite un peu plus grande
  // qu'une gravure longue : reduction tres legere (10% max) au-dela de 14
  // caracteres, pour reproduire cet effet sans jamais trop rapetisser.
  function engraveFontScale(text) {
    var len = (text || '').length;
    return 1 - Math.min(0.1, Math.max(0, (len - 14) * 0.0035));
  }

  // Filet de securite iOS : un texte long sur un petit format peut rester
  // sous 16px meme apres calcul -> zoom auto au focus. Pendant que la fenetre
  // de gravure est ouverte (et seulement sur iPhone/iPad), maximum-scale=1
  // bloque ce zoom auto (iOS laisse quand meme le pincement manuel). Jamais
  // applique ailleurs : sur Android, maximum-scale bloquerait le pincement.
  var IS_IOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var viewportMeta = document.querySelector('meta[name="viewport"]');
  var viewportOriginal = viewportMeta ? viewportMeta.getAttribute('content') : null;
  function lockIosZoom(on) {
    if (!IS_IOS || !viewportMeta) return;
    viewportMeta.setAttribute('content', on ? viewportOriginal + ',maximum-scale=1' : viewportOriginal);
  }
  function focusEnd(el) { try { el.focus(); if (el.setSelectionRange) { var n = (el.value || '').length; el.setSelectionRange(n, n); } } catch (e) {} }

  function initSimple(block) {
    var mainInput = block.querySelector('.field__input');
    if (!mainInput) return;
    var multi = makeMultiController(block, {
      visibleInput: mainInput,
      getVisibleValue: function () { return mainInput.value; },
      setVisibleValue: function (v) { mainInput.value = v; },
      onFocus: function () { mainInput.focus(); },
    });
    if (!multi) return;
    block._tdpMulti = multi;
    block._tdp = {
      deactivate: function () { mainInput.disabled = true; multi.setAllDisabled(true); },
      activate: function () { mainInput.disabled = false; multi.setAllDisabled(false); },
      isEmpty: function () { return !mainInput.value; },
    };
    mainInput.addEventListener('input', function () { multi.onValueCommitted(mainInput.value); });
  }

  function initMetallic(block) {
    var overlay = block.querySelector('[data-tdp-overlay]');
    var square = block.querySelector('[data-tdp-square]');
    var editable = block.querySelector('[data-tdp-editable]'); // <input> visible sur le zinc
    var count = block.querySelector('[data-tdp-count]');
    var input = block.querySelector('[data-engrave-input]');   // <input> cache -> panier
    var mini = block.querySelector('.tdp-mini');
    var meta = block.querySelector('.tdp-perso__meta');
    var valueEl = block.querySelector('[data-tdp-value]');
    var errorEl = overlay.querySelector('[data-tdp-error]');
    var multi = null; // controleur multi-objets (gravure differente par quantite), branche plus bas
    // Marque-pages (carre tres etroit, aspect-ratio 4/15) : le placeholder
    // "Ecrivez ici" sur une seule ligne debordait largement - affiche sur 2
    // lignes ("Ecrivez" / "ici") pour ce format uniquement.
    var isElongated = overlay.classList.contains('tdp-perso--elongated');
    if (isElongated) editable.placeholder = 'Écrivez\nici';
    // Marque-page Surprise specifiquement : le texte tape ne doit jamais
    // depasser 7 lignes (meme s'il en tiendrait 8 dans le carre).
    var isSurprise = block.dataset.productHandle === 'marque-page-surprise';
    // Porte-cle "Je t'aime" specifiquement : police agrandie de 30%.
    var isKeychainJeTaime = block.dataset.productHandle === 'porte-cle-je-taime';
    // Empreinte : texte de gravure legerement plus petit (cf. fitEditableTo).
    var isEmpreinte = block.dataset.productHandle === 'empreinte';

    // Le carre d'apercu depasse volontairement la hauteur de la colonne
    // label/valeur/bouton a cote (x1.3, a la demande) : taille posee en JS
    // sur 130% de la hauteur reelle de cette colonne, recalculee a chaque
    // changement de mise en page. Centre verticalement par .tdp-perso__row
    // (align-items:center), il deborde alors symetriquement au-dessus/en
    // dessous de la colonne texte, dans l'espace du padding du cadre. La
    // colonne elle-meme reste compacte (CSS) et le texte y est plafonne a
    // 2 lignes, donc ce carre ne peut pas grossir demesurement.
    if (mini && meta && typeof ResizeObserver === 'function') {
      var miniRO = new ResizeObserver(function () {
        var h = meta.getBoundingClientRect().height;
        if (h) mini.style.setProperty('--tdp-mini-size', (h * 1.3) + 'px');
      });
      miniRO.observe(meta);
    }
    var MAX = Number(editable.getAttribute('data-max')) || 60;
    var i18nEdit = input.dataset.i18nEdit || 'Edit';
    var i18nPreview = input.dataset.i18nPreview || 'Preview';
    var i18nToBeDefined = input.dataset.i18nToBeDefined || 'to be defined…';

    // <dialog> sorti au <body> (hors du <form>) : top layer, immunise aux ancetres.
    var secKey = block.dataset.section || '';
    var dupd = document.querySelector('body > .tdp-dialog[data-tdp-body="' + secKey + '"]');
    if (dupd) dupd.remove();
    overlay.setAttribute('data-tdp-body', secKey);
    document.body.appendChild(overlay);

    input.disabled = true; // vide -> ne pas soumettre la propriete

    function updateCount() { count.textContent = engravedLength(editable.value || '') + '/' + MAX; }
    // Limite de caracteres avec les retours a la ligne comptes (cf.
    // engravedLength) : le texte tape ou colle qui la depasse est raccourci.
    var lastValid = '';
    function enforceMax() {
      var v = editable.value;
      if (engravedLength(v) <= MAX) { lastValid = v; return; }
      var p = 0;
      while (p < v.length && p < lastValid.length && v.charAt(p) === lastValid.charAt(p)) p++;
      var s = 0;
      while (s < v.length - p && s < lastValid.length - p && v.charAt(v.length - 1 - s) === lastValid.charAt(lastValid.length - 1 - s)) s++;
      var head = v.slice(0, p), added = v.slice(p, v.length - s), tail = v.slice(v.length - s);
      while (added && engravedLength(head + added + tail) > MAX) added = added.slice(0, -1);
      editable.value = head + added + tail;
      editable.setSelectionRange(head.length + added.length, head.length + added.length);
      lastValid = editable.value;
    }
    var focusCard = block.querySelector('.tdp-focus');
    var focusControls = block.querySelector('.tdp-focus__controls');
    // La fenetre (.tdp-focus) a une taille fixe et carree (CSS). Le carre de
    // gravure a l'interieur est redimensionne ici pour tenir exactement dans
    // l'espace restant sous le texte d'aide + les boutons - garantit que tout
    // rentre sans jamais deborder ni laisser un vide, quel que soit le ratio
    // du produit (carre, empreinte, marque-page...) ou la longueur des textes.
    function syncFocusSquare() {
      var zinc = square.querySelector('.tdp-zinc');
      if (!focusCard || !zinc) return;
      var cardRect = focusCard.getBoundingClientRect();
      var cs = getComputedStyle(focusCard);
      var padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
      var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
      var gap = parseFloat(cs.rowGap || cs.gap) || 0;
      var controlsH = focusControls ? focusControls.getBoundingClientRect().height : 0;
      var availW = cardRect.width - padX;
      var availH;
      if (overlay.classList.contains('tdp-perso--keychain2')) {
        // Ce produit : le cadre exterieur epouse son contenu (hauteur:auto, cf
        // CSS) - il deprendrait donc circulairement de la taille qu'on calcule.
        // On se base sur la hauteur de la fenetre du navigateur (fixe) plutot
        // que sur le cadre lui-meme.
        availH = (window.innerHeight * 0.86) - padY - gap - controlsH;
      } else {
        availH = cardRect.height - padY - gap - controlsH;
      }
      if (availH <= 20 || availW <= 20) return;
      var ratio = 1;
      var arStr = getComputedStyle(zinc).aspectRatio;
      if (arStr && arStr.indexOf('/') > -1) {
        var parts = arStr.split('/');
        var rw = parseFloat(parts[0]), rh = parseFloat(parts[1]);
        if (rw && rh) ratio = rw / rh;
      }
      square.style.width = Math.min(availW, availH * ratio) + 'px';
    }
    // Les boutons (Annuler/Valider) collent exactement a la largeur reelle du
    // carre (variable CSS --tdp-focus-w lue par .tdp-focus__controls), plutot
    // qu'une largeur fixe independante qui les faisait deborder plus large que l'image.
    function syncFocusWidth() {
      if (!focusCard) return;
      var w = square.getBoundingClientRect().width;
      if (w) focusCard.style.setProperty('--tdp-focus-w', w + 'px');
    }
    // Taille RESPONSIVE : dans un carre bien plus haut que large de ligne, la
    // hauteur deborde rarement meme avec beaucoup de texte -> une recherche
    // basee sur la hauteur reste quasiment tout le temps au maximum, quelle
    // que soit la longueur (c'etait le bug). On se base donc d'abord sur la
    // LARGEUR (comme sur les pieces reelles : la taille suit directement le
    // nombre de caracteres a faire tenir sur une ligne, via un span miroir -
    // meme technique que fitInput()) ; un filet de securite sur la hauteur
    // reduit encore si un texte multi-lignes finit quand meme par deborder.
    function sizeEditable() {
      syncFocusSquare();
      // Placeholder ("Ecrivez ici") : toujours affiche a 48px (60px -20%),
      // fixe, peu importe le carre - ne passe pas par le calcul responsive
      // ci-dessous. Sauf marque-pages (carre etroit) : deborde a 48px fixe,
      // reste donc responsive comme le texte tape (cf. plus bas).
      if (!editable.value && !isElongated) {
        var phPx = isKeychainJeTaime ? Math.round(48 * 1.3 * 0.7) : 48;
        editable.style.paddingLeft = ''; editable.style.paddingRight = '';
        editable.style.paddingTop = '0px'; editable.style.paddingBottom = '0px';
        editable.style.fontSize = phPx + 'px';
        centerEditable();
        syncFocusWidth();
        return phPx;
      }
      var w = square.getBoundingClientRect().width || 500;
      // Largeur du carre vue par le client : reutilisee pour recalculer a
      // l'identique la gravure de production (cf. measureEngraving).
      // Largeur CSS (offsetWidth) et non a l'ecran : l'animation d'ouverture
      // (scale) fausserait sinon la valeur pendant quelques centaines de ms.
      block._tdpLastSquareW = square.offsetWidth || w;
      var best = fitEditableTo(editable, w);
      centerEditable();
      syncFocusWidth();
      return best;
    }
    // Largeur du produit en cm ("Dimension : 12 x 12 cm" dans la description),
    // dans le sens de la largeur de l'apercu (cf. buildProductionSpecs).
    function productWidthCm(ed) {
      var dim = productDimension(block);
      if (!dim) return null;
      var landscape = ed.offsetWidth >= ed.offsetHeight;
      return (landscape ? Math.max(dim[0], dim[1]) : Math.min(dim[0], dim[1])) / 10;
    }
    // Caracteres par ligne pour un produit de largeur widthCm (cm) : maxChars
    // pour une ligne coupee a un espace, maxCharsLong pour un mot sans espace
    // (cf. fitEditableTo). Dimension inconnue : maxChars = 0.
    function lineLimits(widthCm) {
      var narrowProduct = isElongated || isKeychainJeTaime;
      var maxChars = widthCm ? Math.max(1, Math.floor(widthCm * (narrowProduct ? 3 : 2) + 1e-9)) : 0;
      var maxCharsLong = widthCm ? Math.max(maxChars, Math.floor(widthCm * (narrowProduct ? 4 : 3) + 1e-9)) : 20;
      if (widthCm && isElongated) { maxChars = 8; maxCharsLong = 13; }
      // Porte-cles paysage (Porte-cle Skyline et variante Skyline du porte-cle
      // grave Paris) : 3 par cm (19 sur 6,5 cm), 4 par cm pour un mot sans espace.
      if (widthCm && overlay.classList.contains('tdp-perso--keychain2')) {
        maxChars = Math.max(1, Math.floor(widthCm * 3 + 1e-9));
        maxCharsLong = Math.max(maxChars, Math.floor(widthCm * 4 + 1e-9));
      }
      return { maxChars: maxChars, maxCharsLong: maxCharsLong };
    }
    // Caracteres par ligne du carre de gravure (fenetre ouverte ou non : sens
    // de la largeur lu sur les proportions du carre).
    function lineChars() {
      var dim = productDimension(block);
      if (!dim) return 0;
      var landscape;
      if (editable.offsetWidth) landscape = editable.offsetWidth >= editable.offsetHeight;
      else {
        var ar = getComputedStyle(square.querySelector('.tdp-zinc')).aspectRatio || '';
        var parts = ar.split('/');
        landscape = parts.length < 2 || parseFloat(parts[0]) >= parseFloat(parts[1]);
      }
      return lineLimits((landscape ? Math.max(dim[0], dim[1]) : Math.min(dim[0], dim[1])) / 10).maxChars;
    }
    // Caracteres comptes : un retour a la ligne compte aussi les caracteres
    // qui pouvaient encore tenir sur sa ligne (ligne vide : une ligne entiere).
    function engravedLength(text) {
      var perLine = lineChars();
      if (!perLine) return text.length;
      var lines = text.split('\n'), n = 0;
      lines.forEach(function (line, i) {
        n += i === lines.length - 1 ? line.length : Math.max(1, Math.ceil(line.length / perLine)) * perLine;
      });
      return n;
    }
    // Calcul de la taille du texte pour un carre de largeur w (logique
    // d'origine de sizeEditable, isolee pour pouvoir etre rejouee sur une
    // copie invisible du carre au moment de l'ajout au panier).
    function fitEditableTo(editable, w) {
      // Maximum : moitie de la base d'origine, +10% ; minimum : base d'origine
      // x0.22, +20%. Marque-pages : carre bien plus etroit -> lettres agrandies
      // de 300% (x4) par rapport a cette meme base, a la demande.
      var prevMaxPx = Math.max(24, Math.min(140, Math.round(w * 0.16)));
      // Marque-pages : x3.2 (au lieu de x4) -> environ 10 caracteres par ligne
      // au lieu de 8 (police reduite d'env. 20%, chars/ligne inversement
      // proportionnel a la taille de police, a largeur de carre egale).
      var sizeMul = isElongated ? 3.2 : (isKeychainJeTaime ? 1.3 : 1);
      var maxPx = Math.max(12, Math.round(prevMaxPx * 0.5 * 1.10 * sizeMul));
      var minPx = Math.max(12, Math.round(prevMaxPx * 0.22 * 1.20 * sizeMul));
      // Marque-page Surprise : -5% puis -5% puis +5% puis -2% puis +1% (net environ -5.9%).
      if (isSurprise) minPx = Math.max(12, Math.round(minPx * 0.95 * 0.95 * 1.05 * 0.98 * 1.01));
      editable.style.paddingTop = '0px'; editable.style.paddingBottom = '0px';
      // Marges laterales de la CSS (15 %), sauf texte trop haut (cf. plus bas).
      editable.style.paddingLeft = ''; editable.style.paddingRight = '';

      var cs = getComputedStyle(editable);
      var placeholderMode = !editable.value && isElongated;
      // Marge de securite plus large pour le placeholder ("Ecrivez" ne doit
      // JAMAIS se couper en 2 - un simple ecart d'arrondi entre la mesure du
      // miroir et le rendu reel du textarea suffisait a le faire deborder d'un
      // cheveu et casser le mot en plein milieu).
      // Texte tape : 70 % de la largeur du carre (marges de 15 % de chaque
      // cote, cf. padding CSS), la marge de 0,5 % evite un retour a la ligne
      // sur un ecart d'arrondi.
      var availW = (editable.clientWidth - (parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight))) * (placeholderMode ? 0.85 : 0.995);
      MIRROR.style.fontFamily = cs.fontFamily; MIRROR.style.fontWeight = cs.fontWeight; MIRROR.style.letterSpacing = cs.letterSpacing;
      // Caracteres par ligne : au plus 2 par cm de largeur du produit (24 sur
      // le carre de 12 cm). Un mot sans espace plus long que ca peut monter a
      // 3 par cm sur sa ligne (36 sur le carre) ; au-dela, il est coupe.
      // Produits etroits (les 2 marque-pages, porte-cle grave Paris) : 3 par cm,
      // 4 par cm pour un mot sans espace (16 sur 4 cm). Les 2 marque-pages : 8
      // caracteres par ligne quand le texte peut etre coupe a un espace, 13 pour
      // un mot sans espace.
      // Dimension inconnue : ancien comportement (passage a la ligne a la
      // taille minimale, mot de 20 caracteres jamais coupe).
      var widthCm = productWidthCm(editable);
      var limits = lineLimits(widthCm);
      var maxChars = limits.maxChars, maxCharsLong = limits.maxCharsLong;
      var landscapeKeychain = overlay.classList.contains('tdp-perso--keychain2');
      // Taille maximale sur ces porte-cles (texte court -12 %, -15 % de plus
      // jusqu'a 15 caracteres) : le texte ne prend jamais toute la plaque.
      var landscapeCap = function (longest) { return Math.round(prevMaxPx * 0.5 * 1.10) * 0.8 * 1.1 * (longest <= 15 ? 0.85 : 1); };
      // Placeholder marque-page sur 2 lignes ("Ecrivez" / "ici") : la ligne la
      // plus large des deux pilote la largeur, "Ecrivez" est la plus longue.
      MIRROR.textContent = editable.value || (isElongated ? 'Écrivez' : editable.placeholder) || '';
      var lo = minPx, hi = maxPx, best = minPx;
      if (placeholderMode || !editable.value) {
        while (lo <= hi) { var mid = (lo + hi) >> 1; MIRROR.style.fontSize = mid + 'px'; if (MIRROR.getBoundingClientRect().width > availW) hi = mid - 1; else { best = mid; lo = mid + 1; } }
      } else {
        // La ligne la plus large remplit toujours les 70 % du centre. Jusqu'a
        // 15 caracteres sur la ligne la plus longue, la taille reste plafonnee
        // (maxPx) : un texte court ne remplit pas forcement les 70 %.
        var text = editable.value;
        var longestLine = text.split('\n').reduce(function (a, b) { return b.length > a ? b.length : a; }, 0);
        // Espacement des lettres en em (comme la CSS), pour mesurer juste a chaque taille essayee.
        var lsEm = (parseFloat(cs.letterSpacing) || 0) / (parseFloat(cs.fontSize) || 1);
        MIRROR.style.letterSpacing = lsEm + 'em';
        // Lignes affichees par le <textarea> a une taille donnee, lues sur une
        // copie <div> invisible avec la meme mise en forme (cf. measureEngraving).
        var wrapMir = document.createElement('div');
        ['fontFamily', 'fontWeight', 'fontStyle', 'textAlign', 'whiteSpace', 'overflowWrap', 'wordBreak', 'paddingLeft', 'paddingRight', 'textTransform'].forEach(function (p) { wrapMir.style[p] = cs[p]; });
        wrapMir.style.position = 'absolute'; wrapMir.style.left = '-20000px'; wrapMir.style.top = '0'; wrapMir.style.visibility = 'hidden';
        wrapMir.style.boxSizing = 'border-box'; wrapMir.style.margin = '0'; wrapMir.style.paddingTop = '0'; wrapMir.style.paddingBottom = '0';
        wrapMir.style.width = editable.clientWidth + 'px';
        wrapMir.style.lineHeight = String((parseFloat(cs.lineHeight) / parseFloat(cs.fontSize)) || 1.25);
        wrapMir.style.letterSpacing = lsEm + 'em';
        wrapMir.textContent = text;
        document.body.appendChild(wrapMir);
        var range = document.createRange();
        var shortScale = 1;
        var wrapLines = function (px) {
          wrapMir.style.fontSize = px + 'px';
          var node = wrapMir.firstChild, out = [], cur = null, top = null;
          for (var i = 0; node && i < text.length; i++) {
            var ch = text.charAt(i);
            if (ch === '\n') { out.push(cur = { s: '' }); top = null; continue; }
            range.setStart(node, i); range.setEnd(node, i + 1);
            var rs = range.getClientRects();
            var r = rs.length ? rs[rs.length - 1] : null;
            if (!r) continue;
            if (!cur || (top !== null && Math.abs(r.top - top) > px * 0.5)) {
              // Un espace qui provoque le retour a la ligne reste en fin de ligne precedente.
              if (cur && /\s/.test(ch)) { cur.s += ch; continue; }
              out.push(cur = { s: '' }); top = null;
            }
            if (top === null) top = r.top;
            cur.s += ch;
          }
          return out.map(function (l) { return l.s.trim(); });
        };
        // Limite de caracteres respectee sur chaque ligne (ligne d'un seul mot
        // plus long que la limite : 3 caracteres par cm).
        var charsOk = function (px) {
          if (!maxChars) return true;
          return wrapLines(px).every(function (l) { return l.length <= (/\s/.test(l) ? maxChars : maxCharsLong); });
        };
        // Chaque mot (ses premiers caracteres au-dela de la limite des mots
        // longs) tient en entier sur une ligne : jamais coupe en plein milieu.
        MIRROR.textContent = text.split(/\s+/).filter(Boolean).map(function (t) { return t.length > maxCharsLong ? t.slice(0, maxCharsLong) : t; }).join('\n');
        var wordsFit = function (px) { MIRROR.style.fontSize = px + 'px'; return MIRROR.getBoundingClientRect().width <= availW; };
        // Plus grande taille entre lo et hi qui verifie ok (ok(lo) suppose vrai).
        var bisectMax = function (lo, hi, ok) {
          if (ok(hi)) return hi;
          for (var k = 0; k < 24 && hi - lo > 0.05; k++) { var m = (lo + hi) / 2; if (ok(m)) lo = m; else hi = m; }
          return Math.floor(lo * 100) / 100;
        };
        // Plus petite taille entre lo et hi qui verifie ok (ok(hi) suppose vrai).
        var bisectMin = function (lo, hi, ok) {
          if (ok(lo)) return lo;
          for (var k = 0; k < 24 && hi - lo > 0.05; k++) { var m = (lo + hi) / 2; if (ok(m)) hi = m; else lo = m; }
          return Math.ceil(hi * 100) / 100;
        };
        try {
          var LO = maxChars ? 4 : minPx, HI = Math.max(maxPx, w * 0.5);
          var fWords = wordsFit(LO) ? bisectMax(LO, HI, wordsFit) : LO;
          // Plus petite taille ou les lignes respectent la limite de caracteres.
          var fChars = charsOk(fWords) ? bisectMin(LO, fWords, charsOk) : fWords;
          // On l'agrandit tant que le nombre de lignes ne change pas : la ligne
          // la plus large arrive alors aux 70 % du centre.
          var n0 = wrapLines(fChars).length;
          best = bisectMax(fChars, fWords, function (px) { return wrapLines(px).length <= n0; });
          // Jusqu'a 15 caracteres sur la ligne la plus longue, la taille reste
          // plafonnee (maxPx) : un texte court ne remplit pas forcement les 70 %.
          // Texte court : plafond reduit de 15 % (tous les produits). Si la limite
          // de caracteres impose une taille plus grande, police et largeur utile
          // sont reduites ensemble (memes retours a la ligne).
          if (longestLine <= 15) {
            var shortCap = maxPx * 0.85;
            if (shortCap >= fChars) best = Math.min(best, shortCap);
            else { best = fChars; shortScale = shortCap / fChars; }
          }
          // Porte-cles paysage : a la taille maximale (ou plus petit pour tenir
          // sur 50 % de la hauteur), le texte est recoupe sur toute la largeur
          // des 70 % si la limite de caracteres le permet. Sinon, reduction
          // police + largeur plus bas (memes retours a la ligne).
          if (landscapeKeychain) {
            var boxHL = editable.clientHeight;
            var heightOk = function (px) { wrapMir.style.fontSize = px + 'px'; return wrapMir.getBoundingClientRect().height <= boxHL * 0.5 + 0.5; };
            var target = Math.min(best, landscapeCap(longestLine));
            var fH = heightOk(target) ? target : (heightOk(LO) ? bisectMax(LO, target, heightOk) : LO);
            if (charsOk(fH) && wordsFit(fH)) { best = fH; shortScale = 1; }
          }
        } finally {
          if (wrapMir.parentNode) wrapMir.parentNode.removeChild(wrapMir);
        }
        if (shortScale < 1) {
          var sFull = editable.clientWidth, sContent = sFull - (parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight));
          var sPad = (sFull - sContent * shortScale) / 2;
          editable.style.paddingLeft = sPad + 'px'; editable.style.paddingRight = sPad + 'px';
          best = Math.floor(best * shortScale * 100) / 100;
        }
      }

      editable.style.fontSize = best + 'px';
      // "Ecrivez" ne doit jamais se couper en 2 lignes - keep-all interdit
      // toute coupure au milieu du mot (le texte tape, lui, garde le
      // comportement normal defini par la CSS partagee : break-word).
      editable.style.wordBreak = placeholderMode ? 'keep-all' : '';
      if (placeholderMode) {
        // scrollHeight d'un textarea vide ne tient pas compte du placeholder :
        // on verifie a la main que les 2 lignes ("Ecrivez"+"ici") tiennent,
        // avec le meme line-height:1.25 que la CSS.
        while (best > minPx && (best * 1.25 * 2) > editable.clientHeight) { best -= 1; editable.style.fontSize = best + 'px'; }
      } else if (!editable.value || !maxChars) {
        while (best > minPx && (editable.scrollHeight > editable.clientHeight || (isSurprise && editable.scrollHeight > best * 1.25 * 7))) { best -= 1; editable.style.fontSize = best + 'px'; }
      } else {
        // Texte trop haut pour le produit : police ET largeur utile reduites
        // dans la meme proportion. Les retours a la ligne restent les memes
        // (limite de caracteres respectee), les marges depassent alors 15 %.
        // Hauteur reelle du texte (bas libere, comme centerEditable) : il doit
        // tenir avec la marge minimale de 8 % en haut et en bas.
        // Porte-cles paysage (Porte-cle Skyline et variante Skyline du porte-cle
        // grave Paris) : le texte ne prend jamais toute la plaque. Taille
        // plafonnee a celle d'un texte court -12 %, quelle que soit la longueur
        // (police et largeur utile reduites ensemble), et texte sur 50 % de la
        // hauteur au plus (cf. tooTall).
        var capPx = landscapeCap(longestLine);
        if (landscapeKeychain && best > capPx) {
          var cFull = editable.clientWidth, cContent = cFull - (parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight));
          var cPad = (cFull - cContent * capPx / best) / 2;
          editable.style.paddingLeft = cPad + 'px'; editable.style.paddingRight = cPad + 'px';
          best = Math.floor(capPx * 100) / 100; editable.style.fontSize = best + 'px';
        }
        var boxH = editable.clientHeight;
        var tooTall = function () {
          editable.style.bottom = 'auto'; editable.style.height = 'auto';
          var h = editable.scrollHeight;
          editable.style.bottom = ''; editable.style.height = '';
          // Hauteur seulement : reduire ensemble police et largeur ne change pas
          // le nombre de lignes (fixe par la limite de caracteres).
          return h > boxH * (landscapeKeychain ? 0.5 : 0.84) + 0.5;
        };
        if (tooTall()) {
          var fullW = editable.clientWidth, contentW = fullW - (parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight)), base = best;
          var applyScale = function (k) {
            var pad = (fullW - contentW * k) / 2;
            editable.style.paddingLeft = pad + 'px'; editable.style.paddingRight = pad + 'px';
            editable.style.fontSize = (base * k) + 'px';
          };
          var kLo = 0.2, kHi = 1;
          for (var kIt = 0; kIt < 20 && kHi - kLo > 0.002; kIt++) {
            var kMid = (kLo + kHi) / 2;
            applyScale(kMid);
            if (tooTall()) kHi = kMid; else kLo = kMid;
          }
          best = Math.floor(base * kLo * 100) / 100;
          var padK = (fullW - contentW * (best / base)) / 2;
          editable.style.paddingLeft = padK + 'px'; editable.style.paddingRight = padK + 'px';
          editable.style.fontSize = best + 'px';
        }
      }
      // Empreinte (article plus grand que les autres) : texte legerement plus
      // petit (-5 %), police et largeur utile reduites ensemble (memes retours
      // a la ligne, marges un peu plus larges que 15 %).
      if (isEmpreinte && editable.value && !placeholderMode) {
        var eCs = getComputedStyle(editable);
        var eFull = editable.clientWidth, eContent = eFull - (parseFloat(eCs.paddingLeft) + parseFloat(eCs.paddingRight));
        best = Math.floor(best * 0.95 * 100) / 100;
        var ePad = (eFull - eContent * 0.95) / 2;
        editable.style.paddingLeft = ePad + 'px'; editable.style.paddingRight = ePad + 'px';
        editable.style.fontSize = best + 'px';
      }

      // Garantit qu'un mot tape par le client tient toujours sur une seule
      // ligne (jamais coupe puis renvoye a la ligne), quitte a descendre sous
      // la taille minimale habituelle du format - au-dela de 3 caracteres par
      // cm de largeur (20 si la dimension est inconnue), le mot est coupe.
      if (!placeholderMode && editable.value) {
        var tokens = editable.value.split(/\s+/).filter(Boolean);
        var longestWord = tokens.reduce(function (a, b) { return b.length > a.length ? b : a; }, '');
        if (longestWord) {
          var wordSample = longestWord.length > maxCharsLong ? longestWord.slice(0, maxCharsLong) : longestWord;
          MIRROR.style.fontFamily = cs.fontFamily; MIRROR.style.fontWeight = cs.fontWeight;
          MIRROR.style.letterSpacing = ((parseFloat(cs.letterSpacing) || 0) / (parseFloat(cs.fontSize) || 1)) + 'em';
          // Le mot tient deja a la taille retenue : rien a reduire. Sinon, plus
          // grande taille (au dixieme de pixel) ou il tient sur les 70 %.
          MIRROR.style.fontSize = best + 'px'; MIRROR.textContent = wordSample;
          if (MIRROR.getBoundingClientRect().width > availW) {
            var wLo = 8, wHi = best;
            for (var wIt = 0; wIt < 24 && wHi - wLo > 0.05; wIt++) {
              var wMid = (wLo + wHi) / 2;
              MIRROR.style.fontSize = wMid + 'px';
              if (MIRROR.getBoundingClientRect().width > availW) wHi = wMid; else wLo = wMid;
            }
            best = Math.floor(wLo * 100) / 100; editable.style.fontSize = best + 'px';
          }
        }
      }
      return best;
    }
    // Centrage vertical du bloc de texte (le <textarea> aligne en haut par defaut).
    function centerEditable() {
      var H = editable.clientHeight; // hauteur interne du carre (constante, box-sizing:border-box)
      // Le <textarea> est en position:absolute; inset:0 (haut ET bas cloues) -> height:auto ne suffit pas.
      // On libere le bas (bottom:auto) le temps de mesurer la vraie hauteur du texte, puis on remet.
      editable.style.paddingTop = '0px'; editable.style.paddingBottom = '0px';
      editable.style.bottom = 'auto'; editable.style.height = 'auto';
      var contentH = editable.scrollHeight;
      editable.style.bottom = ''; editable.style.height = '';
      var pad = Math.max(H * 0.08, (H - contentH) / 2); // padding symetrique -> bloc reellement centre
      editable.style.paddingTop = pad + 'px';
      editable.style.paddingBottom = pad + 'px';
    }
    // Gravure de production : rejoue exactement le calcul de l'apercu pour un
    // texte donne, sur une copie invisible du carre a la largeur vue par le
    // client (block._tdpLastSquareW). Renvoie la taille de police, la taille
    // du carre et chaque ligne telle qu'affichee (texte + position), pour
    // convertir ensuite a l'echelle reelle du produit (cf. buildProductionSpecs).
    function measureEngraving(text) {
      var seen = block._tdpSeenFont && block._tdpSeenFont[text];
      var w = (seen && seen.w) || block._tdpLastSquareW || 500;
      var host = document.createElement('div');
      host.className = overlay.className.replace(/\btdp-dialog\b/g, ' ');
      host.setAttribute('aria-hidden', 'true');
      host.style.cssText = 'position:fixed;left:-20000px;top:0;visibility:hidden;pointer-events:none;';
      var sq = square.cloneNode(true);
      sq.removeAttribute('data-tdp-square');
      sq.style.width = w + 'px';
      host.appendChild(sq);
      document.body.appendChild(host);
      try {
        var ed = sq.querySelector('textarea');
        ed.removeAttribute('data-tdp-editable');
        ed.value = text;
        var fontPx = fitEditableTo(ed, w);
        if (seen && seen.px) { fontPx = seen.px; ed.style.fontSize = fontPx + 'px'; }
        var zincRect = sq.querySelector('.tdp-zinc').getBoundingClientRect();
        var cs = getComputedStyle(ed);
        // Miroir <div> avec la meme mise en forme que le <textarea>, pour lire
        // les retours a la ligne automatiques et la position de chaque ligne.
        var mir = document.createElement('div');
        ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'letterSpacing', 'lineHeight', 'textAlign', 'whiteSpace', 'overflowWrap', 'wordBreak', 'paddingLeft', 'paddingRight', 'textTransform'].forEach(function (p) { mir.style[p] = cs[p]; });
        mir.style.position = 'absolute'; mir.style.left = '0'; mir.style.top = '0';
        mir.style.boxSizing = 'border-box'; mir.style.width = ed.clientWidth + 'px';
        mir.style.paddingTop = '0'; mir.style.paddingBottom = '0'; mir.style.margin = '0';
        mir.textContent = text;
        host.appendChild(mir);
        var mirRect = mir.getBoundingClientRect();
        var node = mir.firstChild;
        var lines = [];
        var cur = null;
        var range = document.createRange();
        for (var i = 0; node && i < text.length; i++) {
          var ch = text.charAt(i);
          if (ch === '\n') { cur = null; lines.push(cur = { chars: '', top: null, left: null, right: null }); continue; }
          range.setStart(node, i); range.setEnd(node, i + 1);
          var rects = range.getClientRects();
          var r = rects.length ? rects[rects.length - 1] : null;
          if (!r) continue;
          if (!cur || (cur.top !== null && Math.abs(r.top - cur.top) > fontPx * 0.5)) {
            // Un espace qui provoque le retour a la ligne reste en fin de ligne precedente.
            if (cur && /\s/.test(ch)) { cur.chars += ch; continue; }
            lines.push(cur = { chars: '', top: null, left: null, right: null });
          }
          if (cur.top === null) cur.top = r.top;
          cur.chars += ch;
          if (!/\s/.test(ch)) {
            if (cur.left === null || r.left < cur.left) cur.left = r.left;
            if (cur.right === null || r.right > cur.right) cur.right = r.right;
          }
        }
        // Meme centrage vertical que centerEditable(), mesure de la meme facon.
        var H = ed.clientHeight;
        ed.style.paddingTop = '0px'; ed.style.paddingBottom = '0px';
        ed.style.bottom = 'auto'; ed.style.height = 'auto';
        var contentH = ed.scrollHeight;
        var pad = Math.max(H * 0.08, (H - contentH) / 2);
        var lineH = parseFloat(cs.lineHeight) || fontPx * 1.25;
        var out = [];
        var lastTop = null;
        lines.forEach(function (l) {
          var t = l.chars.replace(/\s+$/, '');
          var top = l.top !== null ? l.top - mirRect.top : (lastTop !== null ? lastTop + lineH : 0);
          lastTop = top;
          out.push({
            text: t,
            x: l.left !== null ? l.left - mirRect.left : null,
            w: l.left !== null ? l.right - l.left : 0,
            y: pad + top,
          });
        });
        return {
          text: text,
          fontPx: fontPx,
          fontFamily: cs.fontFamily,
          letterSpacingEm: (parseFloat(cs.letterSpacing) || 0) / fontPx,
          lineHeightRatio: lineH / fontPx,
          squareW: zincRect.width,
          squareH: zincRect.height,
          lines: out,
        };
      } finally {
        host.parentNode && host.parentNode.removeChild(host);
      }
    }
    function setValue(text) {
      input.value = text; input.disabled = text === '';
      if (text === '') { valueEl.textContent = i18nToBeDefined; valueEl.classList.add('tdp-empty'); }
      else { valueEl.textContent = text; valueEl.classList.remove('tdp-empty'); }
      if (multi) multi.onValueCommitted(text);
    }
    // Affiche/efface le message "texte de gravure manquant" DANS la fenetre
    // de gravure elle-meme (appele par validatePersonalizationBeforeSubmit
    // quand l'ouverture automatique de cette fenetre masquerait sinon le
    // bandeau d'erreur habituel, place plus bas sur la fiche produit).
    function showMissingError(message) {
      if (!errorEl) return;
      if (message) { errorEl.textContent = message; errorEl.hidden = false; }
      else { errorEl.hidden = true; }
    }
    function onEdit() {
      enforceMax();
      updateCount(); sizeEditable();
      // Efface l'erreur des que le client commence a corriger, sans attendre "Valider".
      if (errorEl && !errorEl.hidden && editable.value.trim() !== '') showMissingError(false);
    }
    function paintMini(text) {
      mini.classList.add('is-filled');
      mini.innerHTML = '<div class="tdp-zinc"><p class="tdp-zinc__text"></p></div><span class="tdp-mini__edit">' + i18nEdit + '</span>';
      var mt = mini.querySelector('.tdp-zinc__text'); mt.textContent = text; mt.style.whiteSpace = 'pre-wrap';
      // Meme ratio taille/largeur que le carre (0.062) + memes marges 10% -> retours a la ligne identiques, a l'echelle.
      var w = mini.getBoundingClientRect().width || 154;
      mt.style.fontSize = Math.max(4, Math.round(w * 0.062 * engraveFontScale(text))) + 'px';
      // Taille vue dans la fenetre de gravure connue : meme proportion (texte sur les 70 % du centre).
      var seen = block._tdpSeenFont && block._tdpSeenFont[text];
      // Largeur CSS (offsetWidth), pas celle a l'ecran faussee par l'animation d'apparition.
      var zw = mt.parentNode.offsetWidth || w;
      if (seen && seen.px && seen.w) mt.style.fontSize = Math.max(4, zw * seen.px / seen.w) + 'px';
      if (seen && seen.pad > 0.1505) { mt.style.paddingLeft = (seen.pad * 100) + '%'; mt.style.paddingRight = (seen.pad * 100) + '%'; }
      return mt;
    }
    function resetMini() { mini.classList.remove('is-filled'); mini.innerHTML = '<span class="tdp-mini__ph">' + i18nPreview + '</span><span class="tdp-mini__edit">' + i18nEdit + '</span>'; }

    function open() {
      editable.value = input.value || '';
      lastValid = editable.value;
      updateCount();
      lockIosZoom(true);
      if (typeof overlay.showModal === 'function') { if (!overlay.open) overlay.showModal(); } else overlay.setAttribute('open', '');
      // sizeEditable() AVANT le focus : iOS (tous navigateurs, moteur WebKit)
      // zoome la page quand un champ recoit le focus avec une police < 16px.
      // A la 1re ouverture, le textarea etait encore a sa taille CSS par
      // defaut (~15px) au moment du focus -> zoom sur l'apercu ; aux
      // ouvertures suivantes la grande taille calculee restait en place.
      requestAnimationFrame(function () { requestAnimationFrame(function () { sizeEditable(); updateCount(); focusEnd(editable); }); });
    }
    function close() {
      if (typeof overlay.close === 'function') { if (overlay.open) overlay.close(); } else overlay.removeAttribute('open');
      showMissingError(false);
      lockIosZoom(false);
    }

    function validate() {
      var text = (editable.value || '').trim();
      // Le champ cache (type hidden) garde les retours a la ligne tapes par le
      // client. Correspondance texte "aplati" -> texte d'origine conservee pour
      // la gravure de production (cf. attachProductionSpecs).
      block._tdpRawTexts = block._tdpRawTexts || {};
      block._tdpRawTexts[text.replace(/[\r\n]/g, '')] = text;
      // Taille reellement affichee au client au moment de valider : c'est
      // elle qui fait foi pour la production (cf. measureEngraving).
      preloadVectorFont();
      block._tdpSeenFont = block._tdpSeenFont || {};
      // pad : marge laterale (part de la largeur), elargie si le texte etait trop haut.
      if (text) block._tdpSeenFont[text] = { px: parseFloat(getComputedStyle(editable).fontSize), w: square.offsetWidth, pad: parseFloat(getComputedStyle(editable).paddingLeft) / (editable.offsetWidth || 1) };
      setValue(text);
      if (text === '') { resetMini(); close(); return; }
      if (RM.matches) { paintMini(text); close(); return; }

      var focusFontPx = parseFloat(getComputedStyle(editable).fontSize);
      var zincBg = getComputedStyle(square.querySelector('.tdp-zinc')).backgroundImage;
      var fromRect = square.getBoundingClientRect();
      var mt = paintMini(text);
      var toRect = mini.getBoundingClientRect();
      var scale = toRect.width / fromRect.width;
      mt.style.whiteSpace = 'pre-wrap';
      // Taille de la miniature : deja posee par paintMini, a la meme proportion
      // que dans la fenetre de gravure (memes retours a la ligne).

      var flyer = document.createElement('div');
      flyer.className = 'tdp-flyer';
      flyer.style.left = fromRect.left + 'px'; flyer.style.top = fromRect.top + 'px';
      flyer.style.width = fromRect.width + 'px'; flyer.style.height = fromRect.height + 'px';
      flyer.innerHTML = '<div class="tdp-zinc" style="width:100%;height:100%"><p class="tdp-zinc__text"></p></div>';
      document.body.appendChild(flyer);
      flyer.querySelector('.tdp-zinc').style.backgroundImage = zincBg;
      var ft = flyer.querySelector('.tdp-zinc__text'); ft.textContent = text; ft.style.whiteSpace = 'pre-wrap'; ft.style.fontSize = focusFontPx + 'px';
      ft.style.paddingLeft = mt.style.paddingLeft; ft.style.paddingRight = mt.style.paddingRight;

      mini.style.visibility = 'hidden'; close();

      var targetRadius = parseFloat(getComputedStyle(mini).borderRadius) || 8;
      var dx = toRect.left - fromRect.left, dy = toRect.top - fromRect.top;
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        flyer.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ')';
        flyer.style.borderRadius = (targetRadius / scale) + 'px';
      }); });

      var done = false;
      function finish() { if (done) return; done = true; mini.style.visibility = ''; mini.classList.add('tdp-pop'); mini.addEventListener('animationend', function () { mini.classList.remove('tdp-pop'); }, { once: true }); if (flyer.parentNode) flyer.parentNode.removeChild(flyer); }
      flyer.addEventListener('transitionend', finish);
      setTimeout(finish, 700);
    }

    function clear() { setValue(''); resetMini(); close(); }
    // Desactive juste la propriete panier, sans effacer le texte/la miniature deja saisis.
    function deactivate() { input.disabled = true; if (multi) multi.setAllDisabled(true); }
    function activate() { input.disabled = input.value === ''; if (multi) multi.setAllDisabled(false); }

    block.querySelectorAll('[data-tdp-open]').forEach(function (b) { b.addEventListener('click', open); });
    overlay.querySelector('[data-tdp-validate]').addEventListener('click', validate);
    overlay.querySelector('[data-tdp-cancel]').addEventListener('click', function () { if (input.value === '') resetMini(); close(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) { if (input.value === '') resetMini(); close(); } });
    overlay.addEventListener('cancel', function (e) { e.preventDefault(); if (input.value === '') resetMini(); close(); });
    editable.addEventListener('input', onEdit);
    window.addEventListener('resize', function () { if (overlay.open) sizeEditable(); });

    block._tdp = { open: open, clear: clear, deactivate: deactivate, activate: activate, isEmpty: function () { return !input.value; }, overlay: overlay, showMissingError: showMissingError, measure: measureEngraving };
    multi = makeMultiController(block, {
      visibleInput: input,
      getVisibleValue: function () { return input.value; },
      setVisibleValue: function (v) {
        input.value = v; input.disabled = v === '';
        if (v === '') { valueEl.textContent = i18nToBeDefined; valueEl.classList.add('tdp-empty'); }
        else { valueEl.textContent = v; valueEl.classList.remove('tdp-empty'); }
      },
      onLoad: function (v) { if (v) paintMini(v); else resetMini(); },
      onFocus: function () { open(); },
    });
    block._tdpMulti = multi;
    if (input.value) { setValue(input.value); paintMini(input.value); }
  }

  function initPersonalizationBlock(block) {
    if (block.dataset.tdpPersonalizationInit === 'true') return;
    block.dataset.tdpPersonalizationInit = 'true';
    if (block.querySelector('[data-tdp-overlay]')) initMetallic(block);
    else initSimple(block);
    toggle(block, null, false);
  }

  document.querySelectorAll('[data-product-personalization]').forEach(initPersonalizationBlock);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-product-personalization]')) initPersonalizationBlock(node);
        if (node.querySelectorAll) node.querySelectorAll('[data-product-personalization]').forEach(initPersonalizationBlock);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      document
        .querySelectorAll('[data-product-personalization][data-section$="' + event.data.sectionId + '"]')
        .forEach(function (block) { toggle(block, event.data.variant, true); });
    });
  }

  // Pas d'emoji dans le texte a graver (non gravables) : le selecteur d'emoji
  // du navigateur/OS (clic droit > Emoji, Win + .) ne peut pas etre retire,
  // donc on filtre les caracteres a la saisie. Ecoute en phase de capture sur
  // le document pour passer AVANT les handlers 'input' du champ (apercu, etc.).
  var EMOJI_RE = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{2300}-\u{23FF}\u{FE0F}\u{200D}\u{20E3}\u{E0020}-\u{E007F}\u{1F1E6}-\u{1F1FF}]/gu;
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('[data-tdp-editable], [data-product-personalization] input[type="text"]')) return;
    if (!EMOJI_RE.test(el.value)) return;
    EMOJI_RE.lastIndex = 0;
    var pos = el.selectionStart;
    var before = el.value.slice(0, pos).replace(EMOJI_RE, '');
    el.value = before + el.value.slice(pos).replace(EMOJI_RE, '');
    el.setSelectionRange(before.length, before.length);
  }, true);

  // Quantite modifiee (input +/- ou saisie directe) : met a jour le nombre
  // d'onglets "Objet N" du bloc de personnalisation correspondant.
  function handleQuantityEvent(e) {
    var target = e.target;
    if (!target || !target.classList || !target.classList.contains('quantity__input')) return;
    var scope = target.closest('product-info') || document;
    scope.querySelectorAll('[data-product-personalization]').forEach(function (block) {
      if (block._tdpMulti) block._tdpMulti.onQuantityChange();
    });
  }
  document.addEventListener('input', handleQuantityEvent);
  document.addEventListener('change', handleQuantityEvent);

  // Bloque l'ajout au panier si un bloc de gravure actif n'a pas de texte
  // (ou, en gravure multi-objets, si un des objets n'en a pas). Ecoute en
  // phase de capture sur le document, AVANT le listener 'submit' pose par
  // product-form.js sur le <form> lui-meme (bubble) : stopImmediatePropagation
  // ici empeche donc bien l'appel AJAX d'ajout au panier de partir.
  function personalizationInputFormId(block) {
    var input = block.querySelector('[data-engrave-input]') || block.querySelector('.field__input');
    return input ? input.getAttribute('form') : null;
  }

  // Cache le message d'erreur "texte de gravure manquant" (s'il est affiche)
  // des que le texte manquant vient d'etre rempli - sans attendre un nouvel
  // essai de soumission.
  function clearMissingTextError(block) {
    var formId = personalizationInputFormId(block);
    var form = formId && document.getElementById(formId);
    if (!form) return;
    var wrapper = form.closest('product-form');
    wrapper = wrapper && wrapper.querySelector('.product-form__error-message-wrapper');
    if (wrapper) wrapper.hidden = true;
  }

  function showFormError(form, message) {
    if (!message) return;
    var wrapper = form.closest('product-form');
    wrapper = wrapper && wrapper.querySelector('.product-form__error-message-wrapper');
    if (!wrapper) return;
    var msgEl = wrapper.querySelector('.product-form__error-message');
    if (msgEl) msgEl.textContent = message;
    wrapper.hidden = false;
  }

  function validatePersonalizationBeforeSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var formId = form.getAttribute('id');
    if (!formId) return;

    var firstInvalid = null;
    document.querySelectorAll('[data-product-personalization]').forEach(function (block) {
      if (firstInvalid) return;
      if (block.dataset.tdpActive !== 'true') return;
      if (personalizationInputFormId(block) !== formId) return;
      if (!block._tdpMulti || !block._tdpMulti.getMissingSlots) return;
      var missing = block._tdpMulti.getMissingSlots();
      if (missing.length) firstInvalid = { block: block, missing: missing };
    });
    if (!firstInvalid) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var tabsEl = firstInvalid.block.querySelector('[data-tdp-tabs]');
    var isMulti = tabsEl && !tabsEl.hidden;
    var message = isMulti ? firstInvalid.block.dataset.i18nMissingMulti : firstInvalid.block.dataset.i18nMissingSingle;
    showFormError(form, message);
    firstInvalid.block._tdpMulti.focusSlot(firstInvalid.missing[0]);
    // La fenetre de gravure (dialog) vient de s'ouvrir en top layer par-dessus
    // le bandeau d'erreur ci-dessus (showFormError) : on affiche donc le meme
    // message DANS la fenetre elle-meme, la ou le regard du client se trouve.
    if (firstInvalid.block._tdp && firstInvalid.block._tdp.showMissingError) {
      firstInvalid.block._tdp.showMissingError(message);
    }
  }
  document.addEventListener('submit', validatePersonalizationBeforeSubmit, true);

  // ------------------------------------------------------------------
  // Gravure de production : a l'ajout au panier, on joint a l'article
  // (proprietes de ligne, visibles dans la commande sur l'admin Shopify,
  // masquees au client grace au "_" en tete de nom), en plus du texte :
  //  - "_Apercu gravure" : PDF a taille reelle (page = produit, texte seul),
  //    pour visualiser la gravure ;
  //  - "_Fichier gravure DXF" : fichier ouvert dans Laser Project (logiciel
  //    de la machine de gravure, qui n'accepte que ce format), meme trace ;
  //  - "_Largeur gravure (Width, mm)" : largeur du bloc de texte, a saisir
  //    dans le champ Width de Laser Project (proportions verrouillees) pour
  //    graver le texte a la taille validee par le client.
  // Cf. Docs/OXYCORE-COMMANDES-PRODUCTION-V1.md (recuperation par OXYCore).
  // Echelle : dimension du produit ("Dimension : 12 x 12 cm" dans la
  // description) / largeur du carre d'apercu. L'apercu ayant les memes
  // proportions que le produit, tout y est a l'echelle : une taille de police
  // de 30 px dans un carre de 500 px pour un produit de 120 mm donne
  // 30 x 120 / 500 = 7,2 mm de corps.
  // ------------------------------------------------------------------
  var ENGRAVE_FONT_NAME = 'Brown Regular';
  var PT_PER_MM = 72 / 25.4;

  function fmtNum(n, d) { return n.toFixed(d).replace('.', ','); }

  // "12 x 12 cm", "12/12 CM", "19,8/14cm", "12CM/10CM", "15cm / 4cm" -> [a, b] en mm.
  function parseDimension(raw) {
    if (!raw) return null;
    var m = /^[^\d]{0,12}?(\d+(?:[.,]\d+)?)\s*(cm|mm)?\s*[x×\/]\s*(\d+(?:[.,]\d+)?)\s*(cm|mm)?/i.exec(String(raw));
    if (!m) return null;
    var unit = (m[4] || m[2] || 'cm').toLowerCase();
    var f = unit === 'mm' ? 1 : 10;
    var a = parseFloat(m[1].replace(',', '.')) * f;
    var b = parseFloat(m[3].replace(',', '.')) * f;
    if (!(a > 0 && b > 0)) return null;
    return [a, b];
  }

  function productDimension(block) {
    var el = document.querySelector('[data-tdp-dimension][data-section="' + (block.dataset.section || '') + '"]') || document.querySelector('[data-tdp-dimension]');
    if (!el) return null;
    try { return parseDimension(JSON.parse(el.textContent)); } catch (e) { return null; }
  }

  // Rapports de la police (hauteur des majuscules, ascendante) mesures sur
  // le rendu reel du navigateur.
  var fontRatioCache = {};
  function fontRatios(fontFamily) {
    if (fontRatioCache[fontFamily]) return fontRatioCache[fontFamily];
    var c = document.createElement('canvas').getContext('2d');
    c.font = '1000px ' + fontFamily;
    var mH = c.measureText('H');
    var r = {
      cap: (mH.actualBoundingBoxAscent || 700) / 1000,
      ascent: (mH.fontBoundingBoxAscent || 800) / 1000,
    };
    fontRatioCache[fontFamily] = r;
    return r;
  }

  // Convertit la mesure de l'apercu (en px) a l'echelle reelle du produit.
  function buildProductionSpecs(m, dim) {
    var spec = { m: m, dim: dim };
    if (!dim) return spec;
    var landscape = m.squareW >= m.squareH;
    var big = Math.max(dim[0], dim[1]), small = Math.min(dim[0], dim[1]);
    spec.realW = landscape ? big : small;
    spec.realH = landscape ? small : big;
    spec.mmPerPx = spec.realW / m.squareW;
    // Controle : l'apercu doit avoir les memes proportions que le produit.
    spec.ratioOk = Math.abs((spec.realW / spec.realH) / (m.squareW / m.squareH) - 1) < 0.03;
    spec.fontMm = m.fontPx * spec.mmPerPx;
    spec.fontPt = spec.fontMm * PT_PER_MM;
    spec.capMm = fontRatios(m.fontFamily).cap * spec.fontMm;
    spec.leadingPt = spec.fontPt * m.lineHeightRatio;
    spec.leadingMm = spec.fontMm * m.lineHeightRatio;
    return spec;
  }

  function specText(spec) {
    var m = spec.m;
    var lines = m.lines.map(function (l) { return '"' + l.text + '"'; }).join(' / ');
    if (!spec.dim) {
      return 'DIMENSION DU PRODUIT INTROUVABLE dans la description (attendu : "Dimension : 12 x 12 cm") - taille non calculee | ' +
        'Police : ' + ENGRAVE_FONT_NAME + ' | Corps : ' + fmtNum(m.fontPx / m.squareW * 100, 2) + ' % de la largeur du produit | ' +
        'Lignes (' + m.lines.length + ') : ' + lines;
    }
    var parts = [
      'Police : ' + ENGRAVE_FONT_NAME,
      'Taille : ' + fmtNum(spec.fontPt, 1) + ' pt (corps ' + fmtNum(spec.fontMm, 2) + ' mm)',
      'Hauteur des majuscules : ' + fmtNum(spec.capMm, 2) + ' mm',
      'Interligne : ' + fmtNum(spec.leadingPt, 1) + ' pt (' + fmtNum(spec.leadingMm, 2) + ' mm)',
      'Approche : +' + Math.round(m.letterSpacingEm * 1000) + ' (' + fmtNum(m.letterSpacingEm, 2) + ' em)',
      'Texte centre',
      'Produit : ' + fmtNum(spec.realW, 0) + ' x ' + fmtNum(spec.realH, 0) + ' mm',
      'Lignes (' + m.lines.length + ') : ' + lines,
    ];
    if (!spec.ratioOk) parts.unshift('ATTENTION : proportions de l\'apercu differentes de la dimension du produit, verifier');
    return parts.join(' | ');
  }

  // --- PDF et DXF de production : vectoriels, aux dimensions reelles du
  // produit, texte seul. Le texte est converti en traces a partir du vrai
  // fichier de police (Brown Regular) : rendu exact meme si la police n'est
  // pas installee sur le poste de gravure. La lecture de police (opentype.js,
  // heberge dans le theme) est prechargee des que le client utilise la
  // gravure ; si elle n'est pas prete au moment de l'ajout au panier, pas de
  // fichier approximatif : une erreur est ecrite a sa place dans la commande.
  // Police lue depuis tdp-engrave-font-data.js (TTF d'origine en base64) et
  // non depuis brown-regular.ttf : le CDN Shopify sert les .ttf convertis en
  // WOFF2, format qu'opentype.js ne sait pas lire.
  var vectorFont = { font: null, loading: false, error: '' };
  function loadScriptOnce(src, test) {
    return new Promise(function (resolve, reject) {
      if (test()) { resolve(); return; }
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = function () { if (test()) resolve(); else reject(new Error('script charge sans effet : ' + src)); };
      s.onerror = function () { reject(new Error('script introuvable : ' + src)); };
      document.head.appendChild(s);
    });
  }
  function preloadVectorFont() {
    if (vectorFont.font || vectorFont.loading) return;
    var cfg = document.querySelector('[data-tdp-dimension][data-font-data-url]');
    if (!cfg || typeof Promise !== 'function') return;
    vectorFont.loading = true;
    loadScriptOnce(cfg.dataset.opentypeUrl, function () { return !!window.opentype; })
      .then(function () { return loadScriptOnce(cfg.dataset.fontDataUrl, function () { return !!window.TDP_ENGRAVE_FONT_TTF_B64; }); })
      .then(function () {
        var bin = atob(window.TDP_ENGRAVE_FONT_TTF_B64);
        var bytes = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        vectorFont.font = window.opentype.parse(bytes.buffer);
      })
      .catch(function (e) {
        vectorFont.loading = false;
        vectorFont.error = (e && e.message) || String(e);
        if (window.console) console.warn('[gravure] police vectorielle indisponible', e);
      });
  }

  // Ligne de base et depart de chaque ligne, en mm depuis le coin haut gauche
  // du produit (meme placement que l'apercu valide par le client).
  function productionLines(spec) {
    var m = spec.m, k = spec.mmPerPx;
    var asc = fontRatios(m.fontFamily).ascent * m.fontPx;
    return m.lines.filter(function (l) { return l.text && l.x !== null; }).map(function (l) {
      return { text: l.text, x: l.x * k, y: (l.y + asc) * k, w: l.w * k };
    });
  }

  // Chaine de metadonnees PDF en UTF-16BE (accents conserves), ASCII seul.
  function pdfTextString(t) {
    var hex = 'FEFF';
    for (var i = 0; i < t.length; i++) hex += ('000' + t.charCodeAt(i).toString(16).toUpperCase()).slice(-4);
    return '<' + hex + '>';
  }

  // Contours du texte grave, en mm depuis le coin haut gauche du produit :
  // sous-chemins de segments droits ('l') et de courbes cubiques ('c', les
  // courbes quadratiques TrueType y sont converties).
  function productionOutlines(spec) {
    if (!vectorFont.font) throw new Error('police de gravure non chargee' + (vectorFont.error ? ' (' + vectorFont.error + ')' : ''));
    var subpaths = [], cur = null;
    productionLines(spec).forEach(function (l) {
      // Comme le texte affiche au client : crenage de la police applique,
      // ligatures desactivees (l'approche les desactive a l'ecran).
      var path = vectorFont.font.getPath(l.text, l.x, l.y, spec.fontMm, { kerning: true, letterSpacing: spec.m.letterSpacingEm, features: { liga: false, rlig: false } });
      var cx = 0, cy = 0;
      path.commands.forEach(function (c) {
        if (c.type === 'M') { subpaths.push(cur = { start: [c.x, c.y], segs: [] }); }
        else if (c.type === 'L') cur.segs.push({ t: 'l', p: [c.x, c.y] });
        else if (c.type === 'C') cur.segs.push({ t: 'c', c1: [c.x1, c.y1], c2: [c.x2, c.y2], p: [c.x, c.y] });
        else if (c.type === 'Q') cur.segs.push({ t: 'c', c1: [cx + 2 / 3 * (c.x1 - cx), cy + 2 / 3 * (c.y1 - cy)], c2: [c.x + 2 / 3 * (c.x1 - c.x), c.y + 2 / 3 * (c.y1 - c.y)], p: [c.x, c.y] });
        else if (c.type === 'Z') { cx = cur.start[0]; cy = cur.start[1]; return; }
        cx = c.x; cy = c.y;
      });
    });
    if (!subpaths.length) throw new Error('aucun texte a graver');
    return subpaths;
  }

  // Contours en polylignes fermees (courbes decoupees par pas de 0,05 mm,
  // ecart a la courbe inferieur au micron), repere bas gauche (Y vers le
  // haut) comme le DXF. Sert aussi a mesurer la largeur du bloc de texte.
  function productionPolylines(spec, subpaths) {
    var H = spec.realH;
    return subpaths.map(function (sp) {
      var pts = [[sp.start[0], H - sp.start[1]]], p0 = sp.start;
      sp.segs.forEach(function (s) {
        if (s.t === 'l') { pts.push([s.p[0], H - s.p[1]]); p0 = s.p; return; }
        var len = Math.hypot(s.c1[0] - p0[0], s.c1[1] - p0[1]) + Math.hypot(s.c2[0] - s.c1[0], s.c2[1] - s.c1[1]) + Math.hypot(s.p[0] - s.c2[0], s.p[1] - s.c2[1]);
        var n = Math.min(200, Math.max(4, Math.ceil(len / 0.05)));
        for (var i = 1; i <= n; i++) {
          var t = i / n, u = 1 - t;
          pts.push([u * u * u * p0[0] + 3 * u * u * t * s.c1[0] + 3 * u * t * t * s.c2[0] + t * t * t * s.p[0],
            H - (u * u * u * p0[1] + 3 * u * u * t * s.c1[1] + 3 * u * t * t * s.c2[1] + t * t * t * s.p[1])]);
        }
        p0 = s.p;
      });
      var out = pts.filter(function (p, i) { return i === 0 || Math.hypot(p[0] - pts[i - 1][0], p[1] - pts[i - 1][1]) > 1e-6; });
      if (out.length > 1 && Math.hypot(out[0][0] - out[out.length - 1][0], out[0][1] - out[out.length - 1][1]) < 1e-6) out.pop();
      return out;
    }).filter(function (p) { return p.length >= 2; });
  }

  // Largeur du bloc de texte grave (de la lettre la plus a gauche a la plus a
  // droite, toutes lignes confondues), en mm : la largeur de l'objet que
  // Laser Project affiche a l'ouverture du DXF.
  function productionWidth(polys) {
    var min = Infinity, max = -Infinity;
    polys.forEach(function (p) { p.forEach(function (q) { if (q[0] < min) min = q[0]; if (q[0] > max) max = q[0]; }); });
    return max - min;
  }

  // PDF 1.4 d'une page aux dimensions du produit : uniquement le texte grave,
  // en traces noirs pleins. Coordonnees du trace en mm (repere haut gauche)
  // converties en points par la matrice de la page.
  function buildProductionPdf(spec, subpaths) {
    var m = spec.m;
    var Wpt = spec.realW * PT_PER_MM, Hpt = spec.realH * PT_PER_MM;
    var f = function (n) { return (Math.round(n * 1000) / 1000).toString(); };
    var ops = [];
    subpaths.forEach(function (sp) {
      ops.push(f(sp.start[0]) + ' ' + f(sp.start[1]) + ' m');
      sp.segs.forEach(function (s) {
        ops.push(s.t === 'l' ? f(s.p[0]) + ' ' + f(s.p[1]) + ' l'
          : f(s.c1[0]) + ' ' + f(s.c1[1]) + ' ' + f(s.c2[0]) + ' ' + f(s.c2[1]) + ' ' + f(s.p[0]) + ' ' + f(s.p[1]) + ' c');
      });
      ops.push('h');
    });
    var content = 'q\n' + PT_PER_MM.toFixed(6) + ' 0 0 ' + (-PT_PER_MM).toFixed(6) + ' 0 ' + f(Hpt) + ' cm\n0 g\n' + ops.join('\n') + '\nf\nQ\n';
    var box = '[0 0 ' + f(Wpt) + ' ' + f(Hpt) + ']';
    var objs = [
      '<< /Type /Catalog /Pages 2 0 R >>',
      '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
      '<< /Type /Page /Parent 2 0 R /MediaBox ' + box + ' /TrimBox ' + box + ' /Resources << >> /Contents 4 0 R >>',
      '<< /Length ' + content.length + ' >>\nstream\n' + content + 'endstream',
      '<< /Title ' + pdfTextString('Gravure - ' + m.lines.map(function (l) { return l.text; }).join(' / ')) +
        ' /Subject ' + pdfTextString(specText(spec)) + ' /Creator ' + pdfTextString('Toit de Paris') + ' /Producer ' + pdfTextString('Toit de Paris - gravure') + ' >>',
    ];
    var out = '%PDF-1.4\n';
    var offsets = [];
    objs.forEach(function (o, i) { offsets.push(out.length); out += (i + 1) + ' 0 obj\n' + o + '\nendobj\n'; });
    var xref = out.length;
    out += 'xref\n0 ' + (objs.length + 1) + '\n0000000000 65535 f \n';
    offsets.forEach(function (o) { out += ('000000000' + o).slice(-10) + ' 00000 n \n'; });
    out += 'trailer\n<< /Size ' + (objs.length + 1) + ' /Root 1 0 R /Info 5 0 R >>\nstartxref\n' + xref + '\n%%EOF\n';
    return out;
  }

  // DXF R12 ASCII (format valide a l'ouverture dans Laser Project), unites mm,
  // origine au coin bas gauche du produit : une polyligne fermee par contour
  // de lettre, calque GRAVURE.
  function buildProductionDxf(spec, polys) {
    var f4 = function (n) { return (Math.round(n * 10000) / 10000).toString(); };
    var out = [];
    var g = function (c, v) { out.push(c, v); };
    g(0, 'SECTION'); g(2, 'HEADER');
    g(9, '$ACADVER'); g(1, 'AC1009'); g(9, '$INSUNITS'); g(70, 4); g(9, '$MEASUREMENT'); g(70, 1);
    g(9, '$EXTMIN'); g(10, 0); g(20, 0); g(30, 0);
    g(9, '$EXTMAX'); g(10, f4(spec.realW)); g(20, f4(spec.realH)); g(30, 0);
    g(0, 'ENDSEC');
    g(0, 'SECTION'); g(2, 'TABLES'); g(0, 'TABLE'); g(2, 'LAYER'); g(70, 1);
    g(0, 'LAYER'); g(2, 'GRAVURE'); g(70, 0); g(62, 7); g(6, 'CONTINUOUS');
    g(0, 'ENDTAB'); g(0, 'ENDSEC');
    g(0, 'SECTION'); g(2, 'ENTITIES');
    polys.forEach(function (p) {
      g(0, 'POLYLINE'); g(8, 'GRAVURE'); g(66, 1); g(10, 0); g(20, 0); g(30, 0); g(70, 1);
      p.forEach(function (q) { g(0, 'VERTEX'); g(8, 'GRAVURE'); g(10, f4(q[0])); g(20, f4(q[1])); g(30, 0); });
      g(0, 'SEQEND'); g(8, 'GRAVURE');
    });
    g(0, 'ENDSEC'); g(0, 'EOF');
    return out.join('\r\n') + '\r\n';
  }

  // Joint un fichier genere a l'article (ou, en cas d'echec, le message
  // d'erreur a sa place, visible dans la commande).
  function addProductionFile(block, formId, name, fileName, type, build) {
    try {
      if (typeof DataTransfer !== 'function') throw new Error('navigateur sans DataTransfer');
      var dt = new DataTransfer();
      dt.items.add(new File([build()], fileName, { type: type }));
      var fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.name = name;
      fileInput.files = dt.files;
      if (!fileInput.files || !fileInput.files.length) throw new Error('fichier non attache');
      addProductionInput(block, formId, fileInput);
    } catch (err) {
      addProductionValue(block, formId, name, 'ERREUR fichier : ' + ((err && err.message) || err));
    }
  }

  function addProductionValue(block, formId, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    addProductionInput(block, formId, input);
  }

  function clearProductionInputs(block) {
    (block._tdpProdInputs || []).forEach(function (el) { el.parentNode && el.parentNode.removeChild(el); });
    block._tdpProdInputs = [];
  }

  function addProductionInput(block, formId, el) {
    el.setAttribute('form', formId);
    el.hidden = true;
    el.setAttribute('data-tdp-production', '');
    block.appendChild(el);
    block._tdpProdInputs.push(el);
  }

  function attachProductionSpecs(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var formId = form.getAttribute('id');
    if (!formId) return;
    document.querySelectorAll('[data-product-personalization]').forEach(function (block) {
      if (!block._tdp || !block._tdp.measure || !block._tdpMulti || !block._tdpMulti.getTexts) return;
      if (personalizationInputFormId(block) !== formId) return;
      clearProductionInputs(block);
      if (block.dataset.tdpActive !== 'true') return;
      // Jamais bloquant : en cas d'erreur, l'ajout au panier part quand meme
      // (le texte a graver reste dans la commande comme avant).
      try {
        var texts = block._tdpMulti.getTexts();
        var dim = productDimension(block);
        // Objets au texte identique regroupes (un seul calcul, un seul fichier).
        var groups = [];
        var raw = block._tdpRawTexts || {};
        texts.forEach(function (t, idx) {
          t = (t || '').trim();
          if (raw[t]) t = raw[t];
          if (!t) return;
          var g = groups.filter(function (x) { return x.text === t; })[0];
          if (!g) groups.push(g = { text: t, objects: [] });
          g.objects.push(idx + 1);
        });
        if (!groups.length) return;
        var multi = texts.length > 1;
        groups.forEach(function (g) {
          var label = multi
            ? (g.objects.length > 1 ? 'Objets ' + g.objects.join(', ') : 'Objet ' + g.objects[0])
            : '';
          var suffix = label ? ' - ' + label : '';
          var slug = (block.dataset.productHandle || 'produit') + (label ? '-' + label.toLowerCase().replace(/[^a-z0-9]+/g, '-') : '');
          var pdfName = 'properties[_Aperçu gravure' + suffix + ']';
          var dxfName = 'properties[_Fichier gravure DXF' + suffix + ']';
          var widthName = 'properties[_Largeur gravure (Width, mm)' + suffix + ']';
          var spec, subpaths, polys;
          try {
            spec = buildProductionSpecs(block._tdp.measure(g.text), dim);
            if (!spec.dim) throw new Error('dimension du produit introuvable dans la description (attendu : "Dimension : 12 x 12 cm")');
            subpaths = productionOutlines(spec);
            polys = productionPolylines(spec, subpaths);
          } catch (errSpec) {
            // Erreur ecrite dans la commande plutot que rien : visible et diagnosticable.
            addProductionValue(block, formId, dxfName, 'ERREUR calcul gravure : ' + ((errSpec && errSpec.message) || errSpec));
            return;
          }
          addProductionFile(block, formId, pdfName, 'apercu-gravure-' + slug + '.pdf', 'application/pdf', function () { return buildProductionPdf(spec, subpaths); });
          addProductionFile(block, formId, dxfName, 'gravure-' + slug + '.dxf', 'application/dxf', function () { return buildProductionDxf(spec, polys); });
          addProductionValue(block, formId, widthName, fmtNum(productionWidth(polys), 2));
        });
      } catch (err) {
        if (window.console) console.warn('[gravure] specs de production non jointes', err);
        clearProductionInputs(block);
        addProductionValue(block, formId, 'properties[_Fichier gravure DXF]', 'ERREUR gravure : ' + ((err && err.message) || err));
      }
    });
  }
  document.addEventListener('submit', attachProductionSpecs, true);

  // Revenir sur la fiche produit depuis un article du panier (cf.
  // snippets/cart-item-restore-url.liquid + tdp-cart-preview.js) : restaure
  // la quantite et le(s) texte(s) de gravure portes dans l'URL, pour ne pas
  // perdre ce que le client avait deja rempli. item.url gere deja nativement
  // le ?variant=... - seuls la quantite et les proprietes sont a notre charge.
  function restoreFromCartLink() {
    if (!window.location.search) return;
    var params = new URLSearchParams(window.location.search);

    var qtyParam = params.get('quantity');
    if (qtyParam) {
      // Scope au produit principal uniquement : une page produit peut aussi
      // afficher d'autres quantites (produits associes, quick-add), qu'on ne
      // doit pas toucher.
      document.querySelectorAll('product-info:not([id*="quickadd"]) .quantity__input').forEach(function (input) {
        if (String(input.value) === String(qtyParam)) return;
        input.value = qtyParam;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    document.querySelectorAll('product-info:not([id*="quickadd"]) [data-product-personalization]').forEach(function (block) {
      var fieldLabel = block.dataset.fieldLabel || '';
      if (!fieldLabel || !block._tdpMulti) return;
      var list = [];
      var single = params.get('properties[' + fieldLabel + ']');
      if (single !== null) list[0] = single;
      var i = 1;
      while (true) {
        var v = params.get('properties[' + fieldLabel + ' - Objet ' + i + ']');
        if (v === null) break;
        list[i - 1] = v;
        i++;
      }
      if (list.length) block._tdpMulti.restoreTexts(list);
    });

    if (window.history && window.history.replaceState) {
      var toDelete = [];
      params.forEach(function (v, k) {
        if (k === 'quantity' || k.indexOf('properties[') === 0) toDelete.push(k);
      });
      if (toDelete.length) {
        var url = new URL(window.location.href);
        toDelete.forEach(function (k) { url.searchParams.delete(k); });
        window.history.replaceState(null, '', url.pathname + (url.search || '') + url.hash);
      }
    }
  }
  restoreFromCartLink();
})();
